import React, { useState, useEffect, useRef } from 'react';
import Step1Main from './BuySteps/Step1Main';
import Step2Main from './BuySteps/Step2Main';
import Step3Main from './BuySteps/Step3Main';
import CryptoStep1 from './BuySteps/CryptoStep1';
import CryptoStep2 from './BuySteps/CryptoStep2';
import CryptoStep3 from './BuySteps/CryptoStep3';
import CryptoStep4 from './BuySteps/CryptoStep4';
import CardStep1 from './BuySteps/CardStep1';
import CardStep2 from './BuySteps/CardStep2';
import CardStep3 from './BuySteps/CardStep3';
import CardStep4 from './BuySteps/CardStep4';
import CardStep5 from './BuySteps/CardStep5';
import PaymentWidgetStep from './BuySteps/PaymentWidgetStep';
import CheckStatusStep from './BuySteps/CheckStatusStep'; // <-- 1. Importa el nuevo paso

const BuyModal = ({ isOpen, onClose, cryptoType, totalBalance = 0, walletData = [] }) => {
   const [currentStep, setCurrentStep] = useState(0);
   const [selectedOption, setSelectedOption] = useState(null);
   const [selectedProptNetwork, setSelectedProptNetwork] = useState('PROPT (POLYGON)');
   // --- NUEVO ESTADO PARA GUARDAR DATOS ENTRE PASOS ---
   const [buyAmount, setBuyAmount] = useState('');
   const [rateData, setRateData] = useState(null);
   // --- NUEVO ESTADO PARA EL FLUJO DE COMPRA CON CRYPTO ---
   const [cryptoPurchaseData, setCryptoPurchaseData] = useState({
      sourceCurrency: 'BTC',
      sourceAmount: '',
      usdEquivalent: 0
   });
   const prevIsOpen = useRef(isOpen);
   // Este efecto se ejecutará cada vez que el modal se abra
   useEffect(() => {
      // Solo reseteamos el estado si el modal se está abriendo AHORA
      // (es decir, si isOpen es true, pero antes era false).
      if (isOpen && !prevIsOpen.current) {
         console.log("Modal abriéndose: Reseteando estado.");
         setCurrentStep(0);
         setSelectedOption(null);
         setBuyAmount('');
         setRateData(null);
         setCryptoPurchaseData({ sourceCurrency: 'BTC', sourceAmount: '', usdEquivalent: 0 });
      }

      // Actualizamos la referencia con el valor actual para el próximo renderizado.
      prevIsOpen.current = isOpen;
   }, [isOpen]);

   const handleBankTransferClick = () => {
      setSelectedOption('bank');
      setCurrentStep(1);
   };
   const handleCryptoClick = () => {
      setSelectedOption('crypto');
      setCurrentStep(1);
   };
   const handleCardClick = () => {
      setSelectedOption('card');
      setCurrentStep(1);
   };
   if (!isOpen) return null;
   const renderStep = () => {
      if (selectedOption === 'bank') {
         switch (currentStep) {
            case 1:
               // Pasamos el balance y las funciones para actualizar el estado
               return <Step1Main
                  totalBalance={totalBalance}
                  setBuyAmount={setBuyAmount}
                  setCurrentStep={setCurrentStep}
                  buyAmount={buyAmount}
                  selectedProptNetwork={selectedProptNetwork}
                  setSelectedProptNetwork={setSelectedProptNetwork}
               />;
            case 2:
               // Pasamos el monto y la función para guardar la data de la API
               return <Step2Main
                  buyAmount={buyAmount}
                  setRateData={setRateData}
                  setCurrentStep={setCurrentStep}
                  cryptoType={cryptoType}
               />;
            case 3:
               // Pasamos la data de la API para mostrar la confirmación
               return <Step3Main rateData={rateData} />;
            default:
               setCurrentStep(1); // Si no hay paso definido, volver al paso 1
               return <Step1Main setCurrentStep={setCurrentStep} />;
         }
      } else if (selectedOption === 'crypto') {
         switch (currentStep) {
            case 1:
               return <CryptoStep1
                  walletData={walletData}
                  purchaseData={cryptoPurchaseData}
                  setPurchaseData={setCryptoPurchaseData}
                  setCurrentStep={setCurrentStep}
               />;
            case 2:
               return <CryptoStep2
                  purchaseData={cryptoPurchaseData}
                  setRateData={setRateData}
                  setCurrentStep={setCurrentStep}
                  cryptoType={cryptoType}
               />;
            case 3:
               return <PaymentWidgetStep
                  rateData={rateData}
                  setCurrentStep={setCurrentStep}
                  cryptoType={cryptoType}
                  setRateData={setRateData}
               />;
            case 4:
               return <CheckStatusStep
                  rateData={rateData}
                  setCurrentStep={setCurrentStep}
               />;
            case 5:
               return <CryptoStep3 rateData={rateData} />;
            case 6:
               return <CardStep5 setCurrentStep={setCurrentStep} />;
            default:
               setCurrentStep(1); // Si no hay paso definido, volver al paso 1
               return <CryptoStep1 setCurrentStep={setCurrentStep} />;
         }
      } else if (selectedOption === 'card') {
         switch (currentStep) {
            case 1:
               return <CardStep1 setCurrentStep={setCurrentStep} />;
            case 2:
               return <CardStep2 setCurrentStep={setCurrentStep} />;
            case 3:
               return <CardStep3 setCurrentStep={setCurrentStep} />;
            case 4:
               return <CardStep4 setCurrentStep={setCurrentStep} />;
            case 5:
               return <CardStep5 setCurrentStep={setCurrentStep} />;
            default:
               setCurrentStep(1); // Si no hay paso definido, volver al paso 1
               return <CardStep1 setCurrentStep={setCurrentStep} />;
         }
      }
      return (
         <div className="modal_content_body">
            <h3 className="ppt_form_title mb-5 text-center">Select Method of Payment</h3>
            <div className='ppt_deposit_ex buy text-center gap-3'>
               <div
                  className='ppt_deposit_item justify-content-start px-2 anchor'
                  onClick={handleBankTransferClick}
               >
                  <p><small className="d-block fs-6 mb-1">Your Balance</small>
                     <b className="fs-4">
                        ${totalBalance.toFixed(2)}
                     </b>
                  </p>
                  <div className='ppt_deposit_item_imgs'>
                     <img src={process.env.PUBLIC_URL + '/assets/img/lm_icon_dollar.svg'} alt="" style={{ width: '36px' }} />
                  </div>
               </div>
               <div
                  className='ppt_deposit_item justify-content-start px-2 anchor'
                  onClick={handleCryptoClick}
               >
                  <p>Crypto &<br /> Stablecoins</p>
                  <div className='ppt_deposit_item_imgs'>
                     <img src={process.env.PUBLIC_URL + '/assets/img/icon_btc.svg'} alt="" />
                     <img src={process.env.PUBLIC_URL + '/assets/img/icon_usdc.svg'} alt="" />
                  </div>
               </div>
               <div
                  className='ppt_deposit_item justify-content-start px-2 anchor'
                  onClick={handleCardClick}
               >
                  <p>Credit /<br /> Debit Card</p>
                  <div className='ppt_deposit_item_imgs'>
                     <img src={process.env.PUBLIC_URL + '/assets/img/cards.png'} alt="" style={{ width: '99px', height: '31px', objectFit: 'contain' }} />
                  </div>
               </div>
            </div>
         </div>
      );
   };
   return (
      <div className="modal_overlay" onClick={(e) => {
         if (e.target.className === 'modal_overlay') onClose();
      }}>
         <div className="modal_content">
            <div className="modal_content_header">
               <span onClick={onClose} className="modal_content_header_close"></span>
            </div>
            {renderStep()}
         </div>
      </div>
   );
};
export default BuyModal;